import React from 'react';
import Button from '@material-ui/core/Button';
import { Divider } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';

var defaultConfigType = 'VMS';
const configOptions = [
  {
    value: 'VMS',
    label: 'VMS'
  },
  {
    value: 'VSAAS',
    label: 'VSAAS'
  }
];
export default class ConfigProvision extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
  }

  _getInitialState() {
    //Device Provisioning - Set Config/Flavor
    if (this.props.provision === true) {
      return {
        configType: defaultConfigType,
        configName: null,
        flavorName: null,
        label:    null,
        configList: [],
        flavorList: []
      }
    } else {
      //Device Config/Flavor Change
      if (this.props.config) {
        return {
          configType: this.props.config.type,
          configName: this.props.config.configName,
          flavorName: this.props.config.flavorName,
          label:    this.props.config.label,
          configList: [],
          flavorList: []
        }
      }
    }
  }

  componentDidMount() {
    let conType = (this.props.provision === true) ? defaultConfigType : this.props.config.type;
    //this._getConfigListByType('configs', conType);
    //this._getConfigListByType('flavors', conType);
    this.getConfigList(conType);
  }

  handleChange = name => event => {
    if (name === 'configType') {
      var configType = event.target.value;
      this.setState({ [name] : configType});
      //Clear old entries
      //this._getConfigListByType('configs', configType);
      //this._getConfigListByType('flavors', configType);
      this.getConfigList(configType);
    } else {
      this.setState({ [name]: event.target.value });
    }
  };

  _getConfigListByType(configOption, configType) {
    var self = this;
    var callback = {
      success: function(configs) {
        var configList = [];
        configs.map(config => {
          var configNameObj = {};
          configNameObj['value'] = config.name;
          configNameObj['label'] = config.name;
          configNameObj['config'] = config;
          configList.push(configNameObj);
          return configNameObj;
        });
        (configOption === 'configs') ? self.setState({ configList: configList }) : self.setState({ flavorList: configList });
      },
      error: function(err) {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'Configurations couldnot be loaded. ' + errormsg
          )
        );
      }
    };
    AppActions.getConfigurationsByType(
      configOption,
      configType,
      callback
    );
  }

  getConfigList(configType) {
    let cfgList = AppActions.getConfigsByType('configs', configType);
    let flrList = AppActions.getConfigsByType('flavors', configType);
    return Promise.all([cfgList, flrList]).then(results => {
      let configs = results[0];
      let flavors = results[1];
      let configList = [];
      let flavorList = [];
      configList = configs.map(config => {
        var configObj = {};
        configObj['value'] = config.name;
        configObj['label'] = config.name;
        configObj['config'] = config;
        return configObj;
      });
      flavorList = flavors.map(config => {
        var configObj = {};
        configObj['value'] = config.name;
        configObj['label'] = config.name;
        configObj['config'] = config;
        return configObj;
      });
      this.setState({ configList: configList, flavorList: flavorList });
    })
      .catch(err => {
        console.log(err);
        this.setState({ configList: [], flavorList: [] });
      })
  }

  submit() {
    if (this.props.confirmAll) {
      this.props.confirmAll(this.state.configType, this.state.flavorName, this.state.configName, this.state.label);
    } else if(this.props.confirm) {
      this.props.confirm(this.props.device.id, this.props.device.auth_sets[0].id, this.props.device.status,
        this.state.configType, this.state.flavorName, this.state.configName, this.state.label);
    }
  }

  render() {
    var self = this;
    let enableButton = true;
    if (this.props.provision) {
      enableButton = (this.state.configType && this.state.configName && this.state.flavorName);
    } else {
      enableButton = ((this.state.configType !== this.props.config.type ) ||
        (this.state.configName !== this.props.config.configName) ||
        (this.state.flavorName !== this.props.config.flavorName) ||
        (this.state.label !== this.props.config.label));
    }

    var chooseConfig = (
      <div>
        <Divider />
        <TextField
          id="type-select"
          select
          label="Choose a Type"
          value={this.state.configType || ''}
          onChange={this.handleChange('configType')}
          margin="normal"
          disabled={!this.props.provision}
        >
          {configOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <br/>
        <TextField
          id="flavor-select"
          select
          label="Choose a Flavor"
          value={this.state.flavorName || ''}
          onChange={this.handleChange('flavorName')}
          margin="normal"
        >
          {this.state.flavorList.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <br/>
        <TextField
          id="config-select"
          select
          label="Choose a Configuration"
          value={this.state.configName || ''}
          onChange={this.handleChange('configName')}
          margin="normal"
        >
          {this.state.configList.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    );

    var noConfigError = (
      <p style={{ maxWidth: '600px', whiteSpace: 'normal' }} className="bold margin-right inline-block">
        No Configuration/Flavor found.
        Please create a Configuration/Flavor from Configurations Menu.
      </p>
    );

    return (
      <div style={{ minWidth: '35em' }}>
        {(this.props.provision === false || (this.state.configList.length > 0 && this.state.flavorList.length > 0)) ?
          chooseConfig : noConfigError}
        <br />
        <div className="float-right">
          <div>
            <Button style={{ marginRight: '10px' }} onClick={() => self.props.dialogToggle()}>
              Cancel
            </Button>
            <Button disabled={!(enableButton)} variant="contained" onClick={() => self.submit()}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
